(() => {
  if (window.wallifyDrawersInitialized) return;
  window.wallifyDrawersInitialized = true;
  let activeDrawer = null;
  let returnFocus = null;
  let previousOverflow = '';
  let fixedPage = null;
  const bodyProperties = ['position', 'top', 'left', 'right', 'width'];
  function updateDrawerViewport() {
    if (activeDrawer?.dataset.drawer === 'header_menu_drawer') activeDrawer.style.setProperty('--wm-viewport-height', `${window.visualViewport?.height || window.innerHeight}px`);
  }
  window.addEventListener('resize', updateDrawerViewport, { passive: true });
  window.visualViewport?.addEventListener('resize', updateDrawerViewport, { passive: true });

  const focusable = (drawer) => Array.from(drawer.querySelectorAll(
    'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'
  )).filter((element) => !element.closest('[inert]') && element.getClientRects().length);

  const triggersFor = (drawer) => Array.from(document.querySelectorAll('[data-drawer-open]'))
    .filter((trigger) => trigger.dataset.drawerOpen === drawer.dataset.drawer);

  function closeDrawer(restoreFocus = true) {
    if (!activeDrawer) return;
    const drawer = activeDrawer;
    activeDrawer = null;
    drawer.classList.remove('active');
    drawer.removeAttribute('open');
    drawer.inert = true;
    triggersFor(drawer).forEach((trigger) => trigger.setAttribute('aria-expanded', 'false'));
    document.body.style.overflow = previousOverflow;
    if (fixedPage) {
      const page = fixedPage;
      fixedPage = null;
      bodyProperties.forEach(property => { document.body.style[property] = page.styles[property]; });
      const previousScrollBehavior = document.documentElement.style.scrollBehavior;
      document.documentElement.style.scrollBehavior = 'auto';
      window.scrollTo(page.x, page.y);
      document.documentElement.style.scrollBehavior = previousScrollBehavior;
    }
    if (restoreFocus && returnFocus?.isConnected) returnFocus.focus({ preventScroll: true });
    returnFocus = null;
  }

  // I-04: rende visibili, e quindi scaricabili dal lazy-loading, le miniature del menu nascoste a menu chiuso
  // dalla regola inline di snippets/wallify-mobile-navigation.liquid. La classe non viene mai tolta.
  function warmMenuThumbnails() {
    const root = document.documentElement;
    if (!root.classList.contains('wm-nav-warm')) root.classList.add('wm-nav-warm');
  }

  function openDrawer(drawer, trigger) {
    if (activeDrawer === drawer) return;
    if (activeDrawer) closeDrawer(false);
    if (drawer.dataset.drawer === 'header_menu_drawer') warmMenuThumbnails();
    previousOverflow = document.body.style.overflow;
    returnFocus = trigger;
    activeDrawer = drawer;
    drawer.inert = false;
    drawer.classList.add('active');
    drawer.setAttribute('open', '');
    triggersFor(drawer).forEach((button) => button.setAttribute('aria-expanded', 'true'));
    document.body.style.overflow = 'hidden';
    if (drawer.dataset.drawer === 'header_menu_drawer') {
      fixedPage = { x: window.scrollX, y: window.scrollY, styles: Object.fromEntries(bodyProperties.map(property => [property, document.body.style[property]])) };
      Object.assign(document.body.style, { position: 'fixed', top: `${-fixedPage.y}px`, left: `${-fixedPage.x}px`, right: '0', width: '100%' });
      drawer.querySelector('.drawer-content-filter')?.scrollTo(0, 0);
      updateDrawerViewport();
    }
    const content = drawer.querySelector('.drawer-content');
    if (content) content.setAttribute('tabindex', '-1');
    (drawer.querySelector('[data-drawer-close]') || focusable(drawer)[0] || content)?.focus({ preventScroll: true });
  }

  function initialize(root = document) {
    root.querySelectorAll('[data-drawer]').forEach((drawer) => {
      if (drawer === activeDrawer) return;
      drawer.inert = !drawer.hasAttribute('open');
    });
    root.querySelectorAll('.drawer_menu_item').forEach((item) => {
      const panel = item.querySelector(':scope > .drawer_submenu');
      const row = item.querySelector(':scope > .drawer_menu_row');
      if (!panel || !row) return;
      if (item.hasAttribute('data-default-collapsed')) return;
      panel.classList.add('active');
      row.classList.add('active');
      row.setAttribute('aria-expanded', 'true');
      item.classList.add('active');
    });
  }

  document.addEventListener('click', (event) => {
    const openButton = event.target.closest('[data-drawer-open]');
    if (openButton) {
      const drawer = Array.from(document.querySelectorAll('[data-drawer]'))
        .find((candidate) => candidate.dataset.drawer === openButton.dataset.drawerOpen);
      if (drawer) {
        event.preventDefault();
        openDrawer(drawer, openButton);
      }
      return;
    }
    const closeTarget = event.target.closest('[data-drawer-close], [data-drawer-overlay]');
    if (closeTarget && closeTarget.closest('[data-drawer]') === activeDrawer) {
      closeDrawer();
      return;
    }
    const row = event.target.closest('.drawer_menu_row');
    if (!row) return;
    const item = row.closest('.drawer_menu_item');
    const panel = item?.querySelector(':scope > .drawer_submenu');
    if (!panel) return;
    const expanded = row.getAttribute('aria-expanded') !== 'true';
    row.setAttribute('aria-expanded', String(expanded));
    row.classList.toggle('active', expanded);
    item.classList.toggle('active', expanded);
    panel.classList.toggle('active', expanded);
  });

  document.addEventListener('keydown', (event) => {
    if (!activeDrawer || event.defaultPrevented) return;
    if (event.key === 'Escape') {
      event.preventDefault();
      closeDrawer();
      return;
    }
    if (event.key !== 'Tab') return;
    const items = focusable(activeDrawer);
    const first = items[0];
    const last = items[items.length - 1];
    if (!first) {
      event.preventDefault();
      activeDrawer.querySelector('.drawer-content')?.focus({ preventScroll: true });
    } else if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  });

  document.addEventListener('focusin', (event) => {
    if (!activeDrawer || activeDrawer.contains(event.target)) return;
    (focusable(activeDrawer)[0] || activeDrawer.querySelector('.drawer-content'))?.focus({ preventScroll: true });
  });

  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
  document.addEventListener('shopify:section:unload', (event) => {
    if (activeDrawer && event.target.contains(activeDrawer)) closeDrawer(false);
  });
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initialize());
  } else {
    initialize();
  }

  // I-04: miniature del menu preparate al primo segnale di intento (tocco o focus sull'hamburger) e, dove l'hamburger
  // esiste (stesso breakpoint di assets/drawer-menu.css), appena il browser è libero dopo l'evento load. Da 1070 px in su mai.
  const warmOnMenuIntent = (event) => {
    if (event.target?.closest?.('[data-drawer-open="header_menu_drawer"]')) warmMenuThumbnails();
  };
  document.addEventListener('pointerdown', warmOnMenuIntent, { capture: true, passive: true });
  document.addEventListener('focusin', warmOnMenuIntent, true);
  const menuMedia = window.matchMedia('(max-width: 1069px)');
  const scheduleMenuWarmup = () => {
    if (document.readyState !== 'complete' || !menuMedia.matches) return;
    if (typeof window.requestIdleCallback === 'function') window.requestIdleCallback(warmMenuThumbnails, { timeout: 500 });
    else window.setTimeout(warmMenuThumbnails, 0);
  };
  menuMedia.addEventListener?.('change', scheduleMenuWarmup);
  if (document.readyState === 'complete') scheduleMenuWarmup();
  else window.addEventListener('load', scheduleMenuWarmup, { once: true });
})();



